import React from 'react';

import { Message, Icon } from 'semantic-ui-react';

export default function NoQuestionsAssignedToGroup() {
  return (
    <Message info>
      <Icon name="info circle" />
      No questions assigned to this group yet. Add questions from the available list below.
    </Message>
  );
}
